module.exports = __webpack_public_path__ + "img/net.e073b43f.png";